<template>
  <div class="message-retention-container">
    <div class="filter-container">
      <el-form :inline="true" :model="form" size="mini">
        <el-form-item label="关键字">
          <el-input style="width: 200px;" v-model="form.keyword" placeholder="请输入关键词" clearable></el-input>
        </el-form-item>
        <el-form-item label="时间筛选">
          <el-date-picker style="width: 220px;" v-model="timeRangeValue" type="daterange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" @click="getList">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetQueryData">重置</el-button>
          <el-button icon="el-icon-plus" type="primary" @click="openAddFormDialog">新增</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-card>
      <el-table v-loading="loading" :data="list" :border="true" style="width: 100%">
        <el-table-column type="expand" width="50">
          <template slot-scope="{row}">
            <div v-html="row.content"></div>
          </template>
        </el-table-column>
        <el-table-column type="index" label="#" width="50"></el-table-column>
        <el-table-column prop="title" label="标题" width="300"></el-table-column>
        <el-table-column overflow-tooltip="true" prop="summary" label="概述"></el-table-column>
        <el-table-column overflow-tooltip="true" prop="createTime" label="创建时间"></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="{row}">
            <el-button type="text" style="color:#409EFF;" icon="el-icon-edit"
              @click="openEditFormDialog(row)"></el-button>
            <el-button type="text" style="color:#F56C6C;" icon="el-icon-delete" @click="removeHandle(row)"></el-button>
            <el-button type="text" icon="el-icon-view" @click="openContentDialog(row)"></el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination style="margin-top: 20px; text-align: right" @size-change="tableSizeChange"
        @current-change="tablePageIndexChange" :current-page="form.pageIndex" :page-sizes="[10, 20, 50, 100]"
        :page-size="form.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>

    </el-card>

    <!-- 新增弹窗 -->
    <el-dialog append-to-body :close-on-click-modal="false" :title="addForm.id ? '编辑记录' : '新增记录'"
      :visible.sync="addFormDialogVisable" width="50%" @close="dialogCloseHandle">
      <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="100px">
        <el-form-item label="标题" prop="title">
          <el-input v-model="addForm.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="内容">
          <quillEditor style="height: 500px;" v-model="addForm.content" ref="quillEditerRef" :options="editorOption" />
        </el-form-item>
        <el-form-item label="概述">
          <el-input v-model="addForm.summary" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button @click="addFormDialogVisable = false">取消</el-button>
        <el-button type="primary" @click="addFormSubmit">保存</el-button>
      </template>
    </el-dialog>

    <!-- 内容展示 -->
    <el-dialog append-to-body title="消息内容" :visible.sync="contentDialogVisable" width="50%">
      <div v-html="content"></div>
    </el-dialog>

  </div>

</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import { list, info, add, update, remove } from '@/api/message-retention'
export default {
  components: {
    quillEditor
  },
  data () {
    return {
      loading: false,
      timeRangeValue: [],
      form: {
        keyword: null,
        startTime: null,
        endTime: null,
        pageIndex: 1,
        pageSize: 10
      },
      total: 0,
      list: [],
      addFormDialogVisable: false,
      addForm: {
        id: null,
        title: '',
        content: '',
        summary: ''
      },
      addFormRules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
      },
      editorOption: {
        placeholder: '请输入标题及内容...',
        theme: "snow",
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
              ['blockquote', 'code-block'], // 引用  代码块
              [{ header: 1 }, { header: 2 }], // 1、2 级标题
              [{ indent: '-1' }, { indent: '+1' }], // 缩进
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
              [{ align: [] }], // 对齐方式
              ['clean'], // 清除文本格式
            ],
          },
        },
        imageDrop: true,   // 图片拖拽
        imageResize: {     // 图片放大缩小
          displayStyles: {
            backgroundColor: "black",
            border: "none",
            color: "white"
          },
          modules: ["Resize", "DisplaySize", "Toolbar"]
        }
      },
      // 内容展示
      contentDialogVisable: false,
      content: '',
    }
  },
  created () {
    this.getList();
  },
  methods: {
    async getList () {
      this.loading = true;
      try {
        let filterData = {
          ...this.form
        }
        if (this.timeRangeValue && this.timeRangeValue.length > 0) {
          filterData.startTime = this.timeRangeValue[0];
          filterData.endTime = this.timeRangeValue[1];
        }
        let queryData = await list(filterData)
        let { total, data } = queryData.data;
        this.list = data;
        this.total = total;
      } catch (error) {

      }

      this.loading = false;
    },
    resetQueryData () {
      this.form.keyword = null;
      this.form.startTime = null;
      this.form.endTime = null;
      this.form.pageIndex = 1;
      this.form.pageSize = 10;

      this.timeRangeValue = []

      this.getList();
    },
    tableSizeChange (size) {
      this.form.pageSize = size;
      this.getList();
    },
    tablePageIndexChange (index) {
      this.form.pageIndex = index;
      this.getList();
    },
    openAddFormDialog () {
      this.addForm = {
        id: null,
        title: '',
        content: '',
        summary: ''
      }
      this.addFormDialogVisable = true;
    },
    openEditFormDialog (row) {
      this.addForm = {
        id: row.id,
        title: row.title,
        content: row.content,
        summary: row.summary
      }
      this.addFormDialogVisable = true;
    },
    addFormSubmit () {
      this.$refs.addFormRef.validate(async (valid) => {
        if (valid) {

          if (!this.addForm.id) {
            await add(this.addForm)
          }
          else {
            await update(this.addForm)
          }

          this.getList();

          this.addFormDialogVisable = false;
        }
      })
    },
    removeHandle (row) {
      this.$confirm(`此操作将永久删除[${row.title}], 是否继续?`, '提示')
        .then(async () => {
          await remove(row.id)
          this.getList();
        })
    },
    dialogCloseHandle () {
      this.$refs.addFormRef.clearValidate();
    },
    openContentDialog (row) {
      this.content = row.content;
      this.contentDialogVisable = true;
    }
  }
}

</script>

<style lang='scss' scoped>
.message-retention-container {
  width: 100%;
  height: 100%;
}

.filter-container {
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}
</style>
